import React from "react";

const AbaScout = ({ aba, onChangeAba }) => {
  // Função para estilizar abas (mesmo padrão do relatório de fundamentos)
  const tabClass = (active) =>
    `px-4 py-2 rounded-t-md font-semibold cursor-pointer select-none border-b-2 ${
      active
        ? "border-blue-600 text-blue-700 bg-white"
        : "border-grey-200 text-gray-500 hover:border-blue-200"
    }`;

  return (
    <div className="flex mb-0 border-b">
      <button
        className={tabClass(aba === "set")}
        onClick={() => onChangeAba("set")}
        type="button"
      >
        Scout do Set
      </button>

      <button
        className={tabClass(aba === "geral")}
        onClick={() => onChangeAba("geral")}
        type="button"
      >
        Scout Geral
      </button>
      <button
        className={tabClass(aba === "fundamentos")}
        onClick={() => onChangeAba("fundamentos")}
        type="button"
      >
        Relatório por Atleta
      </button>
      <button
        className={tabClass(aba === "rotacao")}
        onClick={() => onChangeAba("rotacao")}
        type="button"
      >
        Mapa de calor
      </button>
    </div>
  );
};

export default AbaScout;
